import { defineMessages } from "react-intl";
const messages = defineMessages({
    actionsEdit: {
        id: "app.admin.communities.editCommunity.actions.edit.text",
        defaultMessage: "Edit community",
    },
    actionsSwitch: {
        id: "app.admin.communities.editCommunity.actions.switch.text",
        defaultMessage: "Community status switch",
    },
    actionsSwitchSuccess: {
        id: "app.admin.communities.editCommunity.actions.switch.success.text",
        defaultMessage: "Community status successfully updated",
    },
});
export default messages;
